import * as React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button } from '../../index';
import {
  GALLERY_TYPES,
  DEFAULT_SHOW_MORE_HEIGHT,
} from '../../../../../constants/proGalleryConstants';
import { loadMoreMedias } from '../../../../../actions/proGalleryActions';
import { st, classes } from './ProGalleryLoadMore.st.css';

const ProGalleryLoadMore = ({
  isMobile,
  type,
  isHashtag,
  loadMoreMedias,
  galleryProps,
  isDispalyShowMoreBtn,
  isDispalyShowMoreBtnHashtag,
  loadMoreBtnText,
  isV4Styles,
}) => {
  const { t } = useTranslation();
  if (
    (!type === GALLERY_TYPES.HASHTAG && !isDispalyShowMoreBtn) ||
    (type === GALLERY_TYPES.HASHTAG && !isDispalyShowMoreBtnHashtag)
  )
    return null;

  return (
    <div
      className={st(classes.root)}
      style={{ height: DEFAULT_SHOW_MORE_HEIGHT + 'px' }}
    >
      <Button
        isOldStyle={isV4Styles}
        isMobile={isMobile}
        content={loadMoreBtnText || t('proGallery.loadMoreBtn')}
        onClick={() => loadMoreMedias(type)}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  isMobile: state.appReducer.isMobile,
  isDispalyShowMoreBtn: state.galleryReducer.feed.isDispalyShowMoreBtn,
  isDispalyShowMoreBtnHashtag:
    state.galleryReducer.hashtags.isDispalyShowMoreBtn,
  loadMoreBtnText: state.settingsReducer.loadMoreBtnText,
  isV4Styles: state.settingsReducer.isV4Styles,
});

const mapDispatchToProps = (dispatch) => ({
  loadMoreMedias: (type) => dispatch(loadMoreMedias(type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProGalleryLoadMore);
